import { MijnRoute } from '../../../mijn-navigatie.model';

export const SELF_SERVICE_ECOMMERCE: MijnRoute = {
    path: 'ecommerce',
    navigationEvent: 'toEcommerce',
    regex: /^\/zelf-regelen\/ecommerce$/,
    webcomponent: 'mijn-ecommerce-payments-webcomponent'
};
